var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFingerprinticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 42.4419C13.4202 38.4749 11.785 33.6486 11.785 28.4373C11.785 21.6885 17.2528 16.2187 23.9975 16.2187C30.7422 16.2187 36.2101 21.6885 36.2101 28.4373M36.872 40.6234C36.652 40.6356 36.4362 40.656 36.2142 40.656C29.4695 40.656 24.0016 35.1861 24.0016 28.4373M26.5388 43.9998C21.35 40.7639 17.8941 35.0049 17.8941 28.4373C17.8941 25.0629 20.6291 22.328 24.0014 22.328C27.3738 22.328 30.1087 25.0629 30.1087 28.4373C30.1087 31.8117 32.8436 34.5467 36.216 34.5467C39.5883 34.5467 42.3233 31.8117 42.3233 28.4373C42.3233 18.3142 34.1205 10.1093 24.0034 10.1093C13.8864 10.1093 5.68359 18.3142 5.68359 28.4373C5.68359 30.6937 5.93611 32.891 6.40042 35.0089M41.0515 11.7263C36.887 6.99561 30.798 4 24.0004 4C17.2027 4 11.1137 6.99561 6.94922 11.7263",
    stroke: "#425976",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprinticon);
export default __webpack_public_path__ + "static/media/fingerprint.icon.c4c24f21d944fd481c6e503721f9278b.svg";
export { ForwardRef as ReactComponent };